module.exports = __webpack_public_path__ + "img/orgDetail_4_small.596a5c6b.png";